import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'RedactConversationItem',
  properties: {
    channel: prop(String),
    itemId: prop(String),
    customerId: prop(String),
  },
});
